import _ from 'lodash';
import filters from './filters/index';
import Store from '$$globalStore';
import filterHelpers from './helpers';
import filterStaticItemsByProperty from './filterStaticItems';
import filterConstants from './constants';
import pricingHelpers from '../../helpers/pricingHelper';

class Filter {
  constructor() {
    this.staticFilterItems = [];
    this.customColumnsFilterItems = [];
    this.projectIds = [];
    this.blockFilterSave = false;
    this.blockFilterRefresh = false;
  }

  initByRoute(route, prevRoute) {
    const prevMode = prevRoute.params?.mode;
    const nextMode = route.params?.mode;

    const enteringExportFromChart =
      nextMode === 'export'
      && prevMode === 'gantt'
      && (
        (route.name === 'project' && prevRoute?.name === 'project'
          && +route.params.projectId === +prevRoute.params.projectId)
        || (route.name === 'projectsMultiView' && prevRoute?.name === 'projectsMultiView'
          && +route.params.multiviewID === +prevRoute.params.multiviewID)
      );

    if (enteringExportFromChart) {
      const cf = Store.getters['filter/currentFilter'];

      if (cf) {
        Store.commit('filter/setExportSessionFilterSnapshot', _.cloneDeep(cf));
      }
    }

    const reportsRouteNames = ['progressReports', 'budgetReports', 'timeReports'];

    const fromTaskRoute = prevRoute.name === 'listTaskRoute';
    const toTaskRoute = route.name === 'listTaskRoute';
    const isEqualReportsRoute = reportsRouteNames.includes(route.name) && prevRoute.name === route.name;
    const isInit = !(fromTaskRoute || toTaskRoute || isEqualReportsRoute);
    const projectIds = filterHelpers.getProjectIdsByRoute(route);

    this.projectIds = projectIds;

    let filterByRoute = null;
    let activeFilter = null;

    this.blockFilterSave = false;
    this.blockFilterRefresh = false;

    // Single project
    if (route.fullPath.includes('/project/') && route.params.mode === 'gantt') {
      filterByRoute = filters.project();
      filterByRoute.project_id = +route.params.projectId;
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.project_id);
    }

    if (route.fullPath.includes('/project/') && route.params.mode === 'board') {
      filterByRoute = filters.boardview();
      filterByRoute.project_id = +route.params.projectId;
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type, filterByRoute.project_id);
    }

    if (route.fullPath.includes('/project/') && route.params.mode === 'list') {
      filterByRoute = filters.list();
      filterByRoute.project_id = +route.params.projectId;
      filterByRoute.properties = _.omit(filterByRoute.properties, filterConstants.PROPERTY.gantt_id); // exclude gantt_id property from single list
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type, filterByRoute.project_id);
    }

    if (route.fullPath.includes('/project/') && route.params.mode === 'calendar') {
      filterByRoute = filters.calendarview();
      filterByRoute.project_id = +route.params.projectId;
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type, filterByRoute.project_id);
    }

    if (route.fullPath.includes('/project/') && route.params.mode === 'workload') {
      filterByRoute = filters.workload('single');
      filterByRoute.project_id = +route.params.projectId;
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type, filterByRoute.project_id);
    }

    if (route.fullPath.includes('/project/') && route.params.mode === 'export') {
      filterByRoute = filters.project();
      filterByRoute.project_id = +route.params.projectId;
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.project_id);

      // this.blockFilterSave = true;
      this.blockFilterRefresh = true;
    }

    // Multi projects
    if (route.fullPath.includes('/projects') && route.params.mode === 'gantt') {
      filterByRoute = filters.multiview();
      filterByRoute.multiview_id = +route.params.multiviewID;
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.multiview_id);
    }

    if (route.fullPath.includes('/projects') && route.params.mode === 'list') {
      filterByRoute = filters.list();
      filterByRoute.multiview_id = +route.params.multiviewID;
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type, filterByRoute.multiview_id);
    }

    if (route.fullPath.includes('/projects') && route.params.mode === 'workload') {
      filterByRoute = filters.workload('multi');
      filterByRoute.multiview_id = +route.params.multiviewID;
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type, filterByRoute.multiview_id);
    }

    if (route.fullPath.includes('/projects') && route.params.mode === 'export') {
      filterByRoute = filters.multiview();
      filterByRoute.multiview_id = +route.params.multiviewID;
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.multiview_id);

      this.blockFilterSave = true;
      this.blockFilterRefresh = true;
    }

    // Reports
    if (route.name === 'userLogs') {
      filterByRoute = filters.userLogs();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);

      const hasActiveValues = activeFilter && Object.values(activeFilter).some(value => value || ((typeof value === 'string' || Array.isArray(value)) && value.length > 0));

      if (!hasActiveValues) {
        activeFilter = filterHelpers.getThisMonthFilter(filterByRoute.properties);
      }
    }

    if (route.name === 'timeReports' && route.params.type === 'timeloglist') {
      filterByRoute = filters.reportsTimeTimeloglist();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);
    }

    if (route.name === 'reportsDetail' && route.params.type === 'costslist') {
      filterByRoute = filters.costslist();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);
    }

    if (route.name === 'progressReports' && route.params?.type === 'statuses') {
      filterByRoute = filters.reportsProgressStatuses();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);
    }

    if (route.name === 'progressReports' && route.params?.type === 'schedule') {
      filterByRoute = filters.reportsProgressSchedule();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);
    }

    if (route.name === 'progressReports' && route.params?.type === 'portfolio') {
      filterByRoute = filters.reportsProgressPortfolio();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);
    }

    if (route.name === 'progressReports' && route.params?.type === 'month') {
      filterByRoute = filters.reportsProgressMonth();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);
    }

    if (route.name === 'progressReports' && route.params?.type === 'milestone') {
      filterByRoute = filters.reportsProgressMilestone();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);
    }

    if (route.name === 'budgetReports' && route.params?.type === 'project') {
      filterByRoute = filters.reportsBudgetProject();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);

      const { baselineEnabled, mode } = route.query;

      if (!isEqualReportsRoute) {
        Store.commit('filter/updateAdvancedSettingsByFilterType', {
          type: filterByRoute.type,
          settings: { baselineEnabled, mode: mode || 'graphic' },
        });
      }
    }

    if (route.name === 'budgetReports' && route.params?.type === 'resource') {
      filterByRoute = filters.reportsBudgetResource();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);

      const { baselineEnabled } = route.query;

      if (!isEqualReportsRoute) {
        Store.commit('filter/updateAdvancedSettingsByFilterType', {
          type: filterByRoute.type,
          settings: { baselineEnabled },
        });
      }
    }

    if (route.name === 'budgetReports' && route.params?.type === 'month') {
      filterByRoute = filters.reportsBudgetMonth();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);
    }

    if (route.name === 'timeReports' && route.params?.type === 'month') {
      filterByRoute = filters.reportsTimeMonth();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);
    }

    if (route.name === 'timeReports' && route.params?.type === 'project') {
      filterByRoute = filters.reportsTimeProject();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);

      const { baselineEnabled, mode } = route.query;

      if (!isEqualReportsRoute) {
        Store.commit('filter/updateAdvancedSettingsByFilterType', {
          type: filterByRoute.type,
          settings: { baselineEnabled, mode: mode || 'graphic' },
        });
      }
    }

    if (route.name === 'timeReports' && route.params?.type === 'resource') {
      filterByRoute = filters.reportsTimeResource();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);

      const { baselineEnabled } = route.query;

      if (!isEqualReportsRoute) {
        Store.commit('filter/updateAdvancedSettingsByFilterType', {
          type: filterByRoute.type,
          settings: { baselineEnabled },
        });
      }
    }

    // Other routes
    if (['listView', 'listTaskRoute'].includes(route.name) && !fromTaskRoute) {
      filterByRoute = filters.list();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type, 'common');

      const hasActiveValues = activeFilter && Object.values(activeFilter).some(value => value || ((typeof value === 'string' || Array.isArray(value)) && value.length > 0));

      if (!hasActiveValues && !toTaskRoute) {
        activeFilter = filterHelpers.getIncompleteTasksFilter(filterByRoute.properties);
      }
    }

    if (route.name === 'workload' || route.name === 'workloadTaskRoute') {
      filterByRoute = filters.workload('multi');
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type, 'common');
    }

    if (route.params.mode === 'history') {
      filterByRoute = filters.history();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](filterByRoute.type);

      this.blockFilterSave = true;
    }

    this.initFilter(filterByRoute, activeFilter, projectIds, isInit);

    const leavingExportToChart =
      prevMode === 'export'
      && nextMode === 'gantt'
      && (
        (route.name === 'project' && prevRoute?.name === 'project'
          && +route.params.projectId === +prevRoute.params.projectId)
        || (route.name === 'projectsMultiView' && prevRoute?.name === 'projectsMultiView'
          && +route.params.multiviewID === +prevRoute.params.multiviewID)
      );

    if (leavingExportToChart) {
      const snapshot = Store.state.filter.exportSessionFilterSnapshot;

      if (snapshot) {
        Store.commit('filter/setCurrentFilter', _.cloneDeep(snapshot));
        this.createFilterItems(Store.getters['filter/currentFilter']);
        Store.commit('filter/updateCurrentFilter', {});
      }

      Store.commit('filter/clearExportSessionFilterSnapshot');
    } else if (prevMode === 'export' && nextMode !== 'export') {
      Store.commit('filter/clearExportSessionFilterSnapshot');
    }
  }

  initForSharedGanttApp(sharedData) {
    let filterByRoute = null;
    let activeFilter = null;
    let projectIds = [];

    if (_.isEmpty(sharedData.multiview)) {
      filterByRoute = sharedData.boardView ? filters.sharedBoard() : filters.sharedGantt();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](sharedData.project.gantt_id);

      projectIds = [sharedData.project.gantt_id];
    } else {
      filterByRoute = filters.multiview();
      activeFilter = Store.getters['filter/getActiveFilterByParams'](sharedData.multiview.id);

      projectIds = sharedData.multiview.ganttIDs;
    }

    this.blockFilterSave = true;
    this.initFilter(filterByRoute, activeFilter, projectIds, true);
  }

  initFilter(_filterByRoute, _activeFilter, projectIds, isInit) {
    const filterByRoute = _filterByRoute;
    let activeFilter = _activeFilter;

    this.projectIds = projectIds;

    // Check filter values
    const hasActiveValues = activeFilter && Object.values(activeFilter).some(value => value || ((typeof value === 'string' || Array.isArray(value)) && value.length > 0));

    if (hasActiveValues) {
      const checkedValues = filterHelpers.checkFilterValues(activeFilter, this.projectIds);

      if (checkedValues) {
        activeFilter = checkedValues;
      }
    }

    // Init
    if (isInit) {
      if (filterByRoute) {
        filterByRoute.properties = _.mapValues(filterByRoute.properties, (value, key) => (activeFilter && _.has(activeFilter, key) ? activeFilter[key] : value));

        if (activeFilter && 'customColumns' in activeFilter) {
          filterByRoute.properties.customColumns = activeFilter.customColumns;
        }

        const mergedProps = {
          ...filterByRoute.properties,
          ...(filterByRoute.properties.customColumns || {}),
        };

        const isEmptyProperties = _.every(mergedProps, value => _.isEmpty(value));
        const mutationName = isEmptyProperties ? 'setDefaultEmptyFilter' : 'setCurrentFilter';

        this.createFilterItems(filterByRoute);
        Store.commit(`filter/${mutationName}`, filterByRoute);
      } else {
        this.staticFilterItems = [];
        this.customColumnsFilterItems = [];
        this.projectIds = [];

        Store.commit('filter/setCurrentFilter', null);
      }

      // Store.commit('filter/setCurrentFilter', filterByRoute);
    }
  }

  updateProjectIdsByRoute(route) {
    this.projectIds = filterHelpers.getProjectIdsByRoute(route);
  }

  initCustomColumnsFilter(properties) {
    const columnIds = [];

    this.projectIds.forEach(projectId => {
      const projectColumnIds = Store.getters['columns/getColumnIdsByProjectId'](projectId);

      projectColumnIds.forEach(columnId => {
        const isAdded = columnIds.find(id => id === columnId);

        if (!isAdded) {
          columnIds.push(columnId);
        }
      });
    });

    if (columnIds.length) {
      columnIds.sort();
      this.createCustomColumnsFilterItems(columnIds, properties);
    }
  }

  createFilterItems(currentFilter) {
    const filterItems = [];
    const { properties } = currentFilter;

    Object.keys(currentFilter?.properties).forEach(prop => {
      if (prop in filterStaticItemsByProperty) {
        filterItems.push(filterStaticItemsByProperty[prop]);
      }
    });

    this.staticFilterItems = filterItems;
    this.updateFilterItemsWithCurrentValues(currentFilter);
  }

  updateFilterItemsWithCurrentValues(currentFilter) {
    let clonedFilterItems = _.cloneDeep(this.staticFilterItems);
    const { type, properties, filter } = currentFilter;
    const filterProps = properties || filter;

    clonedFilterItems = clonedFilterItems.map(item => {
      const filterItem = { ...item };
      const value = filterProps[item.property];

      filterItem.options = filterHelpers.getOptionsByPropAndProjectIds(this.projectIds, item.property, type);
      filterItem.value = value;

      return filterItem;
    });

    this.staticFilterItems = clonedFilterItems;
  }

  createCustomColumnsFilterItems(columnIds, properties) {
    const customColumnsFilterItems = columnIds.filter(columnId => Store.getters['columns/getCustomColumnByIdFromMap'](columnId))
      .map(columnId => filterHelpers.createCustomColumnItem(columnId));

    this.customColumnsFilterItems = customColumnsFilterItems;
    this.updateCustomColumnsItemsWithCurrentValues(properties);
  }

  updateCustomColumnsItemsWithCurrentValues(properties) {
    let customColumnsItems = _.cloneDeep(this.customColumnsFilterItems);

    if (customColumnsItems.length) {
      customColumnsItems = customColumnsItems.filter(item => Store.getters['columns/getCustomColumnByIdFromMap'](item.columnId)).map(item => {
        const columnData = Store.getters['columns/getCustomColumnByIdFromMap'](item.columnId);
        const filterItem = { ...item };

        filterItem.label = columnData.name;
        filterItem.options = filterHelpers.getOptionsForCustomColumnItem(columnData.options, columnData.type);

        if (!properties.customColumns) {
          filterItem.value = null;

          return filterItem;
        }

        const value = properties.customColumns[item.property];

        if (value) {
          filterItem.value = value;
        } else {
          filterItem.value = null;
        }

        return filterItem;
      });

      this.customColumnsFilterItems = customColumnsItems;
    }
  }

   watchChangedFilterProps(newProps, oldProps, handlersByKey) {
    Object.keys(handlersByKey).forEach(key => {
      const newVal = newProps?.[key];
      const oldVal = oldProps?.[key];

      if (!_.isEqual(newVal, oldVal)) {
        return handlersByKey[key](newVal, oldVal);
      }
    })
  }
}

const filter = new Filter();

export default filter;
